module.exports = __webpack_public_path__ + "static/media/screen-icon.8dd7f126.eec829d6.svg";